export default __webpack_public_path__ + "static/coronini__img5-7ec2d2d86750edd4d51ba5747ce46154.png";